import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const getBrands = (params = {}) => {
  const ENDPOINT = SUPPLIER_ENDPOINTS.BRAND.GET;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

export { getBrands };
